import React, { useState, useEffect } from 'react'
import { useAuth } from "../api/authStore"
import { useTheme } from '../contexts/ThemeContext'
import humanFormat from 'human-format'
import moment from 'moment'

export default function TicketDetailsDialog(props) {

    const ticket = props.ticket
    const { isDark } = useTheme()

    const { user, getAccessTokenSilently, setToken, logout } = useAuth()

    const [description, setDescription] = React.useState('')
    const [error, setError] = React.useState(null)
    const [showFullData, setShowFullData] = React.useState(false)

    const handleClose = () => {
        props.setOpen(false)
        setError(null)
        setDescription('')
        setShowFullData(false)
    }

    const handleChangeDescription = (e) => {
        setDescription(e.target.value)
    }

    const handleCloseTicket = async(status) => {
        try {
            // Используем введенное описание или правильную форму статуса
            const defaultMessage = status === 'refund' ? 'refunded' : 'rejected'
            const adminResponse = description.trim() || defaultMessage
            const response = await props.apiClient.setToken(getAccessTokenSilently()).closeTicketdAdmin(ticket?.id, adminResponse, status)

            props.setOpen(false)
        } catch (e) {
            setError(JSON.stringify(e))
        }
    }

    if (!props.open) return null

    return (
        <div 
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'transparent',
                display: 'flex',
                alignItems: 'stretch',
                justifyContent: 'flex-start',
                zIndex: 9999
            }}
            onClick={handleClose}
        >
            <div 
                style={{
                    background: isDark ? 'rgba(20, 20, 20, 0.95)' : 'rgba(255, 255, 255, 0.95)', // Затемненный фон панели
                    backdropFilter: 'blur(10px)', // Размытие фона
                    border: isDark ? '1px solid var(--light-gray)' : '1px solid #e0e0e0',
                    borderRadius: '0 var(--radius-lg) var(--radius-lg) 0',
                    width: '380px',
                    height: '100vh',
                    overflow: 'auto',
                    boxShadow: isDark ? 'var(--shadow-card)' : '0 4px 20px rgba(0, 0, 0, 0.1)',
                    animation: 'slideInFromTop 0.3s ease-out',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Заголовок */}
                <div style={{
                    padding: 'var(--spacing-xl)',
                    borderBottom: isDark ? '1px solid var(--light-gray)' : '1px solid #e0e0e0',
                    background: 'var(--gradient-orange)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    position: 'relative'
                }}>
                    <button
                        onClick={handleClose}
                        style={{
                            position: 'absolute',
                            top: 'var(--spacing-md)',
                            right: 'var(--spacing-md)',
                            background: 'none',
                            border: '1px solid var(--light-gray)',
                            borderRadius: 'var(--radius-full)',
                            width: '32px',
                            height: '32px',
                            color: 'var(--text-light)',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 'var(--text-lg)',
                            transition: 'var(--transition-normal)'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.borderColor = 'var(--primary-orange)'
                            e.target.style.color = 'var(--primary-orange)'
                            e.target.style.backgroundColor = 'var(--dark-gray)'
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.borderColor = 'var(--light-gray)'
                            e.target.style.color = 'var(--text-light)'
                            e.target.style.backgroundColor = 'transparent'
                        }}
                    >
                        ×
                    </button>
                    <h2 style={{
                        margin: 0,
                        fontSize: 'var(--text-xl)',
                        fontWeight: '700',
                        textAlign: 'center',
                        paddingRight: '50px' // Место для кнопки закрытия
                    }}>
                        Ticket ID: {ticket?.id}
                    </h2>
                    <p style={{
                        margin: 'var(--spacing-sm) 0 0 0',
                        fontSize: 'var(--text-sm)',
                        color: isDark ? 'var(--text-muted)' : '#666666',
                        textAlign: 'center',
                        fontFamily: 'var(--font-mono)'
                    }}>
                        Proxy ID: {ticket?.lease?.id}
                    </p>
                </div>

                {/* Контент */}
                <div style={{ 
                    padding: 'var(--spacing-xl)',
                    flex: 1,
                    overflow: 'auto'
                }}>
                    {/* Информация о тикете */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 'var(--spacing-md)',
                        marginBottom: 'var(--spacing-lg)'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: 'var(--spacing-sm) 0',
                            borderBottom: isDark ? '1px solid var(--dark-gray)' : '1px solid #f0f0f0'
                        }}>
                            <span style={{
                                color: isDark ? 'var(--text-muted)' : '#666666',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '500'
                            }}>Reason:</span>
                            <span style={{
                                color: isDark ? 'var(--text-light)' : '#333333',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '600'
                            }}>{ticket?.reason}</span>
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: 'var(--spacing-sm) 0',
                            borderBottom: isDark ? '1px solid var(--dark-gray)' : '1px solid #f0f0f0'
                        }}>
                            <span style={{
                                color: isDark ? 'var(--text-muted)' : '#666666',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '500'
                            }}>Start Date:</span>
                            <span style={{
                                color: isDark ? 'var(--text-light)' : '#333333',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '600'
                            }}>{moment(ticket?.lease?.start).format('MMM-D H:m, YYYY')}</span>
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: 'var(--spacing-sm) 0',
                            borderBottom: isDark ? '1px solid var(--dark-gray)' : '1px solid #f0f0f0'
                        }}>
                            <span style={{
                                color: isDark ? 'var(--text-muted)' : '#666666',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '500'
                            }}>Expire Date:</span>
                            <span style={{
                                color: isDark ? 'var(--text-light)' : '#333333',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '600'
                            }}>{moment(ticket?.lease?.until).format('MMM-D H:m, YYYY')}</span>
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: 'var(--spacing-sm) 0',
                            borderBottom: isDark ? '1px solid var(--dark-gray)' : '1px solid #f0f0f0'
                        }}>
                            <span style={{
                                color: isDark ? 'var(--text-muted)' : '#666666',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '500'
                            }}>Traffic IN:</span>
                            <span style={{
                                color: isDark ? 'var(--text-light)' : '#333333',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '600'
                            }}>{ticket?.lease?.stats?.inBytes > 0 ? humanFormat.bytes(ticket?.lease?.stats?.inBytes, {decimals: 0}) : '0'}</span>
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: 'var(--spacing-sm) 0',
                            borderBottom: isDark ? '1px solid var(--dark-gray)' : '1px solid #f0f0f0'
                        }}>
                            <span style={{
                                color: isDark ? 'var(--text-muted)' : '#666666',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '500'
                            }}>Traffic OUT:</span>
                            <span style={{
                                color: isDark ? 'var(--text-light)' : '#333333',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '600'
                            }}>{ticket?.lease?.stats?.outBytes > 0 ? humanFormat.bytes(ticket?.lease?.stats?.outBytes, {decimals: 0}) : '0'}</span>
                        </div>
                    </div>

                    {/* Поле для описания */}
                    <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                        <label style={{
                            display: 'block',
                            color: isDark ? 'var(--text-muted)' : '#666666',
                            fontSize: 'var(--text-sm)',
                            fontWeight: '500',
                            marginBottom: 'var(--spacing-sm)'
                        }}>
                            Admin Response (optional):
                        </label>
                        <textarea
                            value={description}
                        onChange={handleChangeDescription}
                            placeholder="Enter your response (optional)..."
                            style={{
                                width: '100%',
                                minHeight: '80px',
                                padding: 'var(--spacing-md)',
                                background: isDark ? 'var(--medium-gray)' : '#f8f9fa',
                                border: isDark ? '1px solid var(--light-gray)' : '1px solid #e0e0e0',
                                borderRadius: 'var(--radius-md)',
                                color: isDark ? 'var(--text-light)' : '#333333',
                                fontSize: 'var(--text-sm)',
                                fontFamily: 'inherit',
                                resize: 'vertical',
                                outline: 'none',
                                transition: 'var(--transition-normal)'
                            }}
                            onFocus={(e) => e.target.style.borderColor = 'var(--primary-orange)'}
                            onBlur={(e) => e.target.style.borderColor = isDark ? 'var(--light-gray)' : '#e0e0e0'}
                        />
                    </div>

                    {/* Полные данные */}
                    <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                        <button
                            onClick={() => setShowFullData(!showFullData)}
                            style={{
                                width: '100%',
                                padding: 'var(--spacing-md)',
                                background: isDark ? 'var(--medium-gray)' : '#f8f9fa',
                                border: isDark ? '1px solid var(--light-gray)' : '1px solid #e0e0e0',
                                borderRadius: 'var(--radius-md)',
                                color: isDark ? 'var(--text-light)' : '#333333',
                                fontSize: 'var(--text-sm)',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                transition: 'var(--transition-normal)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.borderColor = 'var(--primary-orange)'
                                e.target.style.backgroundColor = isDark ? 'var(--dark-gray)' : '#e9ecef'
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.borderColor = isDark ? 'var(--light-gray)' : '#e0e0e0'
                                e.target.style.backgroundColor = isDark ? 'var(--medium-gray)' : '#f8f9fa'
                            }}
                        >
                            <span>📋 Full Data</span>
                            <span style={{
                                transform: showFullData ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'var(--transition-normal)'
                            }}>▼</span>
                        </button>

                        {showFullData && (
                            <div style={{
                                marginTop: 'var(--spacing-sm)',
                                padding: 'var(--spacing-md)',
                                background: isDark ? 'var(--dark-gray)' : '#f8f9fa',
                                border: isDark ? '1px solid var(--light-gray)' : '1px solid #e0e0e0',
                                borderRadius: 'var(--radius-md)',
                                maxHeight: '200px',
                                overflow: 'auto'
                            }}>
                                <pre style={{
                                    color: isDark ? 'var(--text-light)' : '#333333',
                                    fontSize: 'var(--text-xs)',
                                    fontFamily: 'var(--font-mono)',
                                    margin: 0,
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    {JSON.stringify(ticket, null, 2)}
                                </pre>
                            </div>
                        )}
                    </div>

                    {/* Ошибка */}
                    {error && (
                        <div style={{
                            padding: 'var(--spacing-md)',
                            background: '#dc3545',
                            border: '1px solid #dc3545',
                            borderRadius: 'var(--radius-md)',
                            color: 'var(--white)',
                            fontSize: 'var(--text-sm)',
                            marginBottom: 'var(--spacing-lg)',
                            textAlign: 'center'
                        }}>
                            {error}
                        </div>
                    )}
                </div>

                {/* Кнопки действий */}
                <div style={{
                    padding: 'var(--spacing-xl)',
                    borderTop: isDark ? '1px solid var(--light-gray)' : '1px solid #e0e0e0',
                    display: 'flex',
                    gap: 'var(--spacing-md)',
                    justifyContent: 'flex-end'
                }}>
                    <button
                        onClick={() => handleCloseTicket('refund')}
                        className="btn btn-primary"
                        style={{
                            background: '#28a745',
                            borderColor: '#28a745',
                            color: 'var(--white)',
                            minWidth: '100px'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#218838'
                            e.target.style.borderColor = '#218838'
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#28a745'
                            e.target.style.borderColor = '#28a745'
                        }}
                    >
                        REFUND
                    </button>
                    <button
                        onClick={() => handleCloseTicket('reject')}
                        className="btn btn-primary"
                        style={{
                            background: '#dc3545',
                            borderColor: '#dc3545',
                            color: 'var(--white)',
                            minWidth: '100px'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#c82333'
                            e.target.style.borderColor = '#c82333'
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#dc3545'
                            e.target.style.borderColor = '#dc3545'
                        }}
                    >
                        REJECT
                    </button>
                </div>
            </div>
        </div>
  )
}